import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProductCard } from '@/components/ProductCard';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';
import { useCart } from '@/lib/cart';
import { Heart } from 'lucide-react';
import { useSEO } from '@/lib/useSEO';
import { toast } from 'sonner';

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { add } = useCart();

  useSEO({
    title: 'Mis favoritos | AutoMarket Colombia',
    description: 'Todos los repuestos que marcaste como favoritos en un solo lugar.',
    canonical: '/favoritos',
  });

  useEffect(() => {
    api.get('/favorites').then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, []);

  const onAdd = (p) => { add(p); toast.success(`${p.name} agregado al carrito`); };

  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Mi cuenta</div>
        <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1 flex items-center gap-2">
          <Heart className="h-7 w-7 text-rose-500 fill-rose-500" /> Mis favoritos
        </h1>

        {!loading && items.length === 0 && (
          <div className="mt-8 border border-slate-200 bg-slate-50 p-12 text-center">
            <Heart className="mx-auto h-10 w-10 text-slate-300" />
            <p className="mt-4 text-slate-600">Aún no tienes productos favoritos</p>
            <Link to="/catalogo" className="mt-4 inline-block">
              <Button className="rounded-none bg-slate-900 hover:bg-slate-800">Explorar catálogo</Button>
            </Link>
          </div>
        )}

        <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((p) => <ProductCard key={p.product_id} product={p} onAdd={onAdd} />)}
        </div>
      </div>
    </Layout>
  );
}
